import styled from "@emotion/styled";
import { Dialog, DialogActions, DialogContent } from "@mui/material";

export const ArticleDialog = styled(Dialog)(({ theme }) => ({
	"& .MuiDialog-paper": {
		[theme.breakpoints.down("sm")]: {
			margin: "16px",
			width: "calc(100% - 32px)"
		}
	}
}));

export const ArticleDialogContent = styled(DialogContent)(({ theme }) => ({
	padding: "24px",
	[theme.breakpoints.down("sm")]: {
		padding: "16px"
	}
}));

export const ArticleSubtitle = styled.p(({ theme }) => ({
	...theme.project.typography.body.body1,
	color: theme.project.colors.fontColors.secondary,
	fontWeight: 500,
	margin: "0 0 20px"
}));

export const ArticleBody = styled.div(({ theme }) => ({
	...theme.project.typography.body.body1,
	color: theme.project.colors.fontColors.main,
	overflowWrap: "anywhere",
	"& > :first-of-type": {
		marginTop: 0
	},
	"& > :last-of-type": {
		marginBottom: 0
	},
	"& a": {
		color: theme.project.colors.primaryColors.main
	},
	"& img": {
		height: "auto",
		maxWidth: "100%"
	},
	"& pre, & table": {
		maxWidth: "100%",
		overflowX: "auto"
	}
}));

export const EmptyArticleBody = styled.p(({ theme }) => ({
	...theme.project.typography.body.body1,
	color: theme.project.colors.fontColors.secondary,
	margin: 0
}));

export const ArticleDialogActions = styled(DialogActions)({
	padding: "16px 24px"
});
